import {ElMessageBox, ElNotification} from "element-plus";
import axios from "axios";
import html2canvas from "html2canvas";
import {isRef} from "vue";

const inputStyle = {'text-align': 'center', 'max-height': '52px', 'overflow-y': 'hidden', 'color':'#333','--el-input-border-color':'transparent','--el-border-color': 'transparent'}

function configObjectNull(obj, excepts) {
    if (obj) {
        for (let key in obj) {
            if (Array.isArray(excepts) && excepts.length != 0) {
                if (!excepts.find(item => item === key)) {
                    obj[key] = null;
                }
            } else {
                obj[key] = null;
            }
        }
    }
}

function confirm(message, yes, no) {
    ElMessageBox.confirm(message, '', {confirmButtonText: '确认', cancelButtonText: '取消', type: 'info', showCancelButton: false, closeOnClickModal: false}).then(yes).catch(no)
}

function request(type, url, postData, success, failure, end) {
    let req = null;
    if (type == 'POST') {
        req = axios.post(url, postData);
    } else if (type == "GET") {
        req = axios.get(url);
    }
    if (req) {
        req.then(function (response) {
            let data = response.data;
            let {msg: message, code} = data;
            if (success){
                success({data, message, code});
            }
        }).catch(function () {
            ElNotification({
                title: '',
                message: '网络请求失败，请稍后重试',
                type: 'error'
            })
            if (failure){
                failure();
            }
        }).finally(end);
    }
}

function post(url, postData, success, failure, end) {
    request("POST", url, postData, success, failure, end);
}

function get(url, success, failure, end) {
    request("GET", url, null, success, failure, end);
}


function canvasConvert(canvas, width, height) {
    const w = canvas.width;
    const h = canvas.height;
    const _canvas = document.createElement('canvas');
    const ctx = _canvas.getContext('2d');
    _canvas.width = width;
    _canvas.height = height;
    ctx.drawImage(canvas, 0, 0, w, h, 0, 0, width, height);
    return _canvas;
}
async function eleToImage(elem) {
    const width = elem.offsetWidth;
    const height = elem.offsetHeight;

    const canvas = document.createElement('canvas');
    const scale = window.devicePixelRatio * 2; // 设备像素比
    canvas.width = width * scale; // 定义canvas 宽度 * 缩放
    canvas.height = height * scale; // 定义canvas高度 * 缩放
    // 放大后再缩小提高清晰度
    canvas.getContext('2d').scale(scale, scale);
    await html2canvas(elem, {
        scale: scale / 2, // 添加的scale 参数
        canvas: canvas, // 自定义 canvas
        width: width, // dom 原始宽度
        height: height,
        useCORS: true // 【重要】开启跨域配置
    })
    const context = canvas.getContext('2d');
    context.webkitImageSmoothingEnabled = false;
    context.imageSmoothingEnabled = false;
    return canvasConvert(canvas, canvas.width, canvas.height);
}

async function screenShot(name, dom, callback){
    await new Promise(resolve => setTimeout(resolve, 1000));
    let doc = dom;
    if (isRef(dom)){
        doc = dom.value;
    }
    if (doc){
        const canvas = await eleToImage(doc);
        downloadFile(name,canvas.toDataURL('image/png'))
        if (callback){
            callback();
        }
    }
}

function downloadFile(filename, canvasImg){
    let a = document.createElement('a');
    a.download = filename;
    a.href = canvasImg;
    a.click();
}

export {configObjectNull, confirm, post, get, screenShot, inputStyle};